module.exports = __webpack_public_path__ + "img/s2-hx-6.391226ff.png";